export default {
  common1: 'คอมมอน1',
}
